import { getCurrentInstance, ComponentInternalInstance, ref, Ref, watch } from '@vue/composition-api';
import i18n, { i18n_t } from '@/locales/i18n';
import smh, { SMH } from '@/renderer/scripts/smh';
import tips, { MsgError } from '@/renderer/scripts/utils/tips';

type Handler = {
  show: Ref<boolean>;
  methods: {
    openDetail: () => void;
    getDetailData: (item: { name: string; path: string[]; spaceId?: SpaceId; spaceOrgId?: number }) => void;
    reset: () => void;
  };
  detailData: Ref<SMH.getDirectoryOrFileInfoData | {}>;
  userData: Ref<FileInfoUserData | {}>;
  loading: Ref<boolean>;
  initWord: Ref<string>;
};

export interface FileInfoUserData {
  accountName: string;
  id: number;
  countryCode: string;
  phoneNumber: string;
  nickname: string;
  isExternal: boolean;
  organizationName: string;
}

export const DetailType = {
  space: i18n_t('空间位置'),
  path: i18n_t('文件路径'),
  fileType: i18n_t('类型'),
  size: i18n_t('大小'),
  creationTime: i18n_t('Special.创建时间'),
  modificationTime: i18n_t('Special.修改时间'),
};
export const BaseDetailType = {
  name: i18n_t('名称'),
  creationPerson: i18n_t('创建人'),
};

export default function handleRowDetail(spaceId?: Ref<SpaceId>): Handler {
  const currComponent = getCurrentInstance() as ComponentInternalInstance;
  const vm = currComponent.proxy;
  const router = vm.$route;
  const show = ref(false);
  const loading = ref(false);
  const detailData = ref<SMH.getDirectoryOrFileInfoData | {}>({});
  const userData = ref<FileInfoUserData | {}>({});
  const initWord = ref('');
  const methods = {
    openDetail(): void {
      show.value = true;
    },
    async getDetailData(item: { name: string; path: string[]; spaceId?: SpaceId; spaceOrgId?: number }) {
      loading.value = true;
      const filePath = (item.path as string[]).join('/');
      let spaceOrgId;
      spaceOrgId = item.spaceOrgId || vm.$store.getters.orgId;
      if (router.query.spaceOrgId) {
        spaceOrgId = router.query.spaceOrgId;
      }
      const fileSpaceId = spaceId?.value ?? item.spaceId;
      if (fileSpaceId === null || fileSpaceId === undefined) {
        loading.value = false;
        return;
      }
      try {
        const options = {
          path: filePath,
          spaceId: fileSpaceId,
          spaceOrgId,
        };
        const { data } = await smh.userAPI.getDirectoryOrFileInfo(options);
        loading.value = false;
        if (!data.fileType && data.type) {
          data.fileType = data.type;
        }
        detailData.value = data;
        userData.value = {
          accountName: data.creationPersonAccountName,
          id: data.creationPersonId,
          countryCode: data.creationPersonCountryCode,
          phoneNumber: data.creationPersonPhoneNumber,
          nickname: data.creationPerson,
          isExternal: data.isExternal,
          organizationName: data.organizationName,
        };
        // 兼容后端没返回sensitiveWordList的情况
        if (data.sensitiveWordList) {
          [initWord.value] = data.sensitiveWordList;
        }
      } catch (err) {
        tips.error(err as MsgError);
        loading.value = false;
      }
    },
    reset() {
      detailData.value = {};
      show.value = false;
    },
  };
  watch(
    () => vm.$route,
    () => {
      methods.reset();
    },
  );

  return { show, methods, detailData, userData, loading, initWord };
}
